


import React, { Component} from 'react'
import ReactPlayer from 'react-player';

import './ProducerPlayer.scss';

type MyProps = {
  url: string;
  name: string;
}

type MyState = {
  id: string,
  url: string,
  name: string,
  playing: boolean,
  muted: boolean,
  loop: boolean,
};


class SimpleVideoPlayerComponent extends Component<MyProps, MyState> {
  player:  any = '';

  state: MyState = {
    id: '',
    url: '',
    name: '',
    playing: true,
    muted: true,
    loop: true,
  }

  constructor(props: any) {
    super(props);
    this.state = {
      ...this.state,
      id: props.id,
      url: props.url,
      name: props.name,
    };
    // this.load(props);
  }

  load = (props) => {
    this.setState({
      playing: true,
    });
  }

  UNSAFE_componentWillReceiveProps(props) {
    // console.log('componentWillReceiveProps', props);
    this.setState({ url: props.url, name: props.name });
  }

  ref = (player: any) => {
    this.player = player
  }

  render () {

    return (

          <div className='player-background'>
            <ReactPlayer
              className='react-player'
              width="100%"
              height="100%"
              ref={this.ref}
              url={this.state.url}
              playing = {this.state.playing}
              muted= {this.state.muted}
              loop = {this.state.loop}
            />
          </div>

    )
  }
}

export default SimpleVideoPlayerComponent;